import { createContext } from "react";

export const INITIAL_STATE = {
  waste_bin_types: [], unit_measure_types: [],
};

export const PublicFacilitiesContext = createContext(INITIAL_STATE);
